<template>
  <div>
    <!-- 课程类型占比 -->
    <Echart :options="options" height="335px" width="100%"></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart';
export default {
  data() {
    return {
      options: {}
    };
  },
  components: {
    Echart
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    cdata: {
      handler(newData) {
        var colorList = [
          '#73DDFF',
          '#73ACFF',
          '#FDD56A',
          '#FDB36A',
          '#FD866A',
          '#9E87FF',
          '#58D5FF'
        ];
        this.options = {
          title: {
            text: '课程类型',
            x: 'center',
            y: '36%',
            textStyle: {
              fontSize: 20,
              color: '#fff'
            }
          },
          tooltip: {
            trigger: 'item',
            // b: name,c:value,d: 自动算出的比例
            formatter: '{b} : {d}%'
          },
          legend: {
            // type: 'scroll',
            // orient: 'vertical',
            left: 'center',
            bottom: '30',
            itemHeight: 16,
            itemWidth: 16,
            formatter: '{name}'
          },
          series: [
            {
              type: 'pie',
              center: ['50%', '40%'],
              radius: ['35%', '45%'],
              hoverOffset: 30,
              emphasis: {
                itemStyle: {
                  borderColor: '#f3f3f3',
                  borderWidth: 2
                }
              },
              itemStyle: {
                normal: {
                  color: function (params) {
                    return colorList[params.dataIndex];
                  },
                  borderColor: '#fff',
                  borderWidth: 2
                }
              },
              label: {
                show: false
              },
              // 智力障碍、自闭症谱系障碍、情绪行为障碍、言语与沟通障碍、肢体障碍、脑瘫、
              data: newData.data
            }
          ]
        };
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
